import React from 'react';
import '../../styles/components/skeleton.css';

/**
 * Skeleton loader pour la liste de restaurants
 * @param {number} count - Nombre d'items skeleton à afficher (défaut: 6)
 */
const RestaurantsSkeleton = ({ count = 6 }) => {
  return (
    <div className="restaurants-skeleton-grid">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="skeleton-restaurant-item">
          <div className="skeleton-restaurant-name"></div>
          <div className="skeleton-restaurant-cuisine"></div>
          <div className="skeleton-attraction-details"></div>
        </div>
      ))}
    </div>
  );
};

export default RestaurantsSkeleton;
